export default "__VITE_ASSET__6155532d__"